module.exports = __webpack_public_path__ + "sgby/img/caiwenji-pic.2c89729.png";